"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalErrorHandler_1 = require("./GlobalErrorHandler");
exports.GlobalErrorHandler = GlobalErrorHandler_1.default;
__export(require("./registerGlobalInterceptor"));
__export(require("./Service/proxy"));
//# sourceMappingURL=index.js.map